import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useMenu } from "../lib/api";
import { useI18n } from "../lib/i18n";
import { Header } from "../components/Header";

// Public legal page (Confidentialité / CGV / Mentions légales). Text comes from production settings
// (legal_privacy / legal_terms / legal_imprint); a neutral placeholder shows until the restaurant fills it in.
const FIELD = { privacy: "legal_privacy", terms: "legal_terms", imprint: "legal_imprint" };
const LABEL = { privacy: "legalPrivacy", terms: "legalTerms", imprint: "legalImprint" };

export default function LegalPage() {
  const { kind } = useParams();
  const navigate = useNavigate();
  const { t, tx } = useI18n();
  const { data } = useMenu();
  const k = kind === "terms" || kind === "imprint" ? kind : "privacy";
  const text = tx(data?.settings?.[FIELD[k]]);

  return (
    <div className="min-h-screen bg-hm-surface">
      <Header />
      <div className="mx-auto w-full max-w-[760px] px-4 py-6">
        <button type="button" data-testid="legal-back" onClick={() => navigate(-1)} className="mb-4 flex h-10 w-10 items-center justify-center rounded-full bg-hm-tertiary text-hm-ink">
          <ArrowLeft size={18} />
        </button>
        <h1 className="font-display text-4xl text-hm-ink" data-testid={`legal-title-${k}`}>{t(LABEL[k])}</h1>
        <p className={`mt-4 whitespace-pre-wrap font-sans text-base leading-6 ${text ? "text-hm-ink" : "italic text-hm-muted"}`} data-testid={`legal-body-${k}`}>
          {text || t("legalPlaceholder")}
        </p>
      </div>
    </div>
  );
}
